/** returns international transfers list
@return { Array }
*/
export const getTmxList = state => state.tmxList
export const getTmxListHasMore = state => state.tmxListHasMore
export const getTmxNumberOfProcess = state => state.tmxNumberOfProcess

/** returns international transfers currencies list
@return { Array }
*/
export const getTmxCurrencyList = state => state.tmxCurrencyList

/** returns international transfers estimated amount
@return { Object }
*/
export const getTmxEstimatedAmount = state => state.tmxEstimatedAmount
